/* Infinite marquee / logo strip.
   Usage:
     <div data-marquee class="overflow-hidden">
       <div class="marquee-track flex gap-12">
         [...logos...]
       </div>
     </div>
   The track content is duplicated in-place so the translateX(-50%) keyframe loops seamlessly. */

export function initMarquees() {
  document.querySelectorAll('[data-marquee]').forEach((root) => {
    const track = root.querySelector('.marquee-track');
    if (!track || track.dataset.doubled === '1') return;

    // Duplicate children so the animation can scroll continuously.
    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentElement.appendChild(clone);

    // Wrap both tracks in a flex row that animates as one unit.
    const wrapper = document.createElement('div');
    wrapper.className = 'flex w-max animate-marquee';
    wrapper.appendChild(track);
    wrapper.appendChild(clone);
    root.appendChild(wrapper);

    track.dataset.doubled = '1';
  });
}
